export default __webpack_public_path__ + "static/media/ContactsMobile.a23598a7.svg";